import React, { useEffect, useState } from 'react';
import { Alert, AlertTitle, Slide, IconButton, Typography, Box, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FeedbackIcon from '@mui/icons-material/Feedback';
import {PrimaryButton} from '../Reusable/Button';

const WelcomeNotice = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hasSeenNotice = localStorage.getItem('welcomeNoticeDismissed');
    if (!hasSeenNotice) {
      const timer = setTimeout(() => setShow(true), 6000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem('welcomeNoticeDismissed', 'true');
  };

  return (
    <Slide direction="down" in={show} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 6000,
          display: 'flex',
          justifyContent: 'center',
          p: 2,
        }}
      >
        <Alert
          severity="success"
          variant="outlined"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{
            bgcolor: '#fefefe',
            borderColor: '#ccc',
            color: '#333',
            width: '100%',
            maxWidth: 600,
            borderRadius: 3,
            p: 2,
          }}
        >
          <AlertTitle sx={{ mb: 1, fontWeight: 'bold' }}>
            Welcome to Yamba Africa!
          </AlertTitle>

          <Typography variant="body2" sx={{ mb: 2 }}>
            We’re excited to have you here. This is the place where your generosity
            creates real impact. Thank you for joining our community of changemakers!
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <PrimaryButton 
            href="https://forms.gle/JxGVzf4V1L3SYwgc7"
              target="_blank"
              rel="noopener noreferrer"
            >
              Share Your Thoughts
            </PrimaryButton>
           
          </Box>
        </Alert>
      </Box>
    </Slide>
  );
};

export default WelcomeNotice;
